import { CSSProp, styled } from "../../styles/stitches.config"
import { SVGProps, ReactElement } from "react"

export const createAnimatedIcon = (icon: (props: SVGProps<SVGSVGElement>) => ReactElement, animation: CSSProp) => {
  return styled(icon, {
    ...animation,
  })
}
